/* "קנה עכשיו": adds the selected variant (with any line item properties) to the cart, then goes straight to checkout.
   Click handling is delegated from the document so it also works for buttons rendered later (quick buy popup, re-rendered product info). */
(function () {
  if (window.nvBuyNow) return;
  window.nvBuyNow = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fallbackError = 'לא הצלחנו להמשיך לתשלום, נסו שוב';

  function errorFor(button) {
    var next = button.nextElementSibling;
    return next && next.classList.contains('nv-buy-now__error') ? next : null;
  }

  function showError(button, message) {
    var error = errorFor(button);
    if (!error) return;
    error.textContent = message;
    error.hidden = !message;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-buy-now]');
    if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

    var form = button.closest('form');
    if (!form || !form.reportValidity()) return;

    showError(button, '');
    button.setAttribute('aria-busy', 'true');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (response.ok) {
          window.location.href = root + 'checkout';
          return;
        }

        return response.json().catch(function () { return {}; }).then(function (data) {
          throw new Error(data.description || data.message || fallbackError);
        });
      })
      .catch(function (error) {
        button.removeAttribute('aria-busy');
        showError(button, (error && error.message) || fallbackError);
      });
  });

  // coming back from checkout with the browser's back button restores the page from cache, so clear the loading state
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-buy-now][aria-busy]').forEach(function (button) {
      button.removeAttribute('aria-busy');
    });
  });

  // the theme enables/disables the add to cart button when the variant changes (sold out, unavailable): mirror it
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var atc = mutation.target;
      if (!atc.matches('buy-buttons button[type="submit"]')) return;

      var buyNow = atc.closest('buy-buttons').querySelector('[data-buy-now]');
      if (buyNow) buyNow.disabled = atc.disabled;
    });
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['disabled'], subtree: true });

  // safety net: after an add to cart the cart drawer must open; if the theme did not open it, open it through the header cart link
  document.addEventListener('variant:add', function () {
    setTimeout(function () {
      var drawer = document.getElementById('cart-drawer');
      if (!drawer || drawer.hasAttribute('open')) return;

      var trigger = document.querySelector('[aria-controls="cart-drawer"]');
      if (trigger) trigger.click();
    }, 900);
  });

  /* ---------------------------------------------------------------------------------------------------------------
     CART DRAWER (Nessova)
     Simple and fast: every tap on + / - / remove updates the screen immediately, the cart requests run one after the
     other, and the drawer is re-rendered ONCE when the queue is empty (one section request, no animation that can get
     stuck). If anything fails, the final re-render shows the real cart again.
     --------------------------------------------------------------------------------------------------------------- */
  var queue = Promise.resolve();
  var pending = 0;
  var refreshId = 0;

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error(path);
      return response;
    });
  }

  function setCheckoutBusy(busy) {
    var button = document.querySelector('cart-drawer [name="checkout"]');
    if (button) button.disabled = busy;
  }

  // re-render the drawer from the server and update the header cart count
  function refreshDrawer() {
    // the theme moves <cart-drawer> to <body>; its (now empty) section wrapper is still in place and carries the section id
    var drawer = document.querySelector('cart-drawer');
    var wrapper = document.querySelector('.shopify-section--cart-drawer');
    if (!drawer || !wrapper) return Promise.resolve();

    var id = ++refreshId;
    var sectionId = wrapper.id.replace('shopify-section-', '');

    return Promise.all([
      fetch(root + '?section_id=' + sectionId).then(function (response) { return response.text(); }),
      fetch(root + 'cart.js').then(function (response) { return response.json(); })
    ]).then(function (results) {
      // a newer tap started meanwhile: its own refresh will follow, do not overwrite it with an old cart
      if (pending > 0 || id !== refreshId) return;

      var fresh = new DOMParser().parseFromString(results[0], 'text/html').querySelector('cart-drawer');
      if (!fresh) return;

      drawer.replaceChildren.apply(drawer, Array.prototype.map.call(fresh.children, function (node) {
        return document.importNode(node, true);
      }));
      ['drawer--center-body', 'nv-has-upsell'].forEach(function (name) {
        drawer.classList.toggle(name, fresh.classList.contains(name));
      });

      var count = results[1].item_count;
      Array.prototype.forEach.call(document.querySelectorAll('cart-count'), function (element) { element.itemCount = count; });
      Array.prototype.forEach.call(document.querySelectorAll('cart-dot'), function (element) { element.classList.toggle('is-visible', count > 0); });
    });
  }

  // run a cart request after the previous ones; re-render the drawer once everything is done
  function run(task) {
    pending++;
    setCheckoutBusy(true);

    queue = queue.then(task).catch(function () {}).then(function () {
      pending--;
      if (pending > 0) return;

      return refreshDrawer().catch(function () {}).then(function () { setCheckoutBusy(false); });
    });
  }

  function collapse(line) {
    line.style.overflow = 'hidden';
    line.style.transition = 'opacity .15s, max-height .2s';
    line.style.maxHeight = line.offsetHeight + 'px';
    line.getBoundingClientRect();
    line.style.opacity = '0';
    line.style.maxHeight = '0';
    line.style.pointerEvents = 'none';
    setTimeout(function () { line.remove(); }, 220);
  }

  function changeLine(line, key, quantity) {
    var input = line.querySelector('input[name="updates[]"]');

    if (quantity <= 0) {
      collapse(line);
    } else if (input) {
      input.value = quantity;
    }

    run(function () { return post('cart/change.js', { id: key, quantity: Math.max(quantity, 0) }); });
  }

  // capture phase: take over the quantity / remove links before the theme's slower handler sees them
  document.addEventListener('click', function (event) {
    var link = event.target.closest('cart-drawer a[href*="/cart/change"]');
    var line = link && link.closest('line-item');
    if (!line) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var key = new URL(link.href, location.origin).searchParams.get('id');
    var input = line.querySelector('input[name="updates[]"]');
    var current = input ? parseInt(input.value, 10) || 1 : 1;
    var next = 0;

    if (link.querySelector('.icon-plus')) next = current + 1;
    else if (link.querySelector('.icon-minus')) next = current - 1;

    changeLine(line, key, next);
  }, true);
})();
